export default __webpack_public_path__ + "static/media/macy's.9e0fa02a.svg";